export class  Sort{

    constructor(
       public sorted?: boolean,
       public empty?: boolean,
       public unsorted?: boolean,
    ) {}
}